import { Dialog } from '@material-ui/core';
import AlertIcon from 'assets/images/notifications/exclamationError.svg?react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'shared/util/utility';

import DialogCard from './dialogCard';

interface ErrorCardProps {
	className?: string;
	icon?: React.FC;
	iconTitle?: string;
	errorMessage?: string;
	onClose: () => void;
	cyActionTextRef?: string;
	cyDescriptionTestRef?: string;
	isGenericTextColor?: boolean;
}

const ErrorCard = (props: ErrorCardProps) => {
	const [t] = useTranslation();

	return (
		<Dialog
			maxWidth="xs"
			fullWidth
			onClose={props.onClose}
			className={`custom-dialog bg--transparent custom--box-shadow text--center ${!isMobile() && 'desktop-dialog'}`}
			aria-labelledby="customized-dialog"
			open={true}
		>
			<DialogCard
				className={`error--card ${props.isGenericTextColor && 'error--card--genericTxtColor'}`}
				icon={() => {
					return props.icon ? <props.icon /> : <AlertIcon />;
				}}
				iconTitle={props.iconTitle || t('error')}
				subDescription={props.errorMessage}
				cardBottomText={t('ok')}
				onActionButtonClick={(e: any) => {
					props.onClose();
				}}
				cyDescriptionTestRef={props.cyDescriptionTestRef}
				cyActionTextRef={props.cyActionTextRef}
			/>
		</Dialog>
	);
};

export default ErrorCard;
